/**
 * 网诊聊天ws封装
 * created by 李智惠 2022-10-30
*/

import { chatList } from "@/api/member"; // 会员请求
import Bus from '@/utils/bus'; // 中央事件总线

let heartbeatTimer = null; // 心跳定时器
let serverTimeoutTimer = null; // 服务器超时断连定时器
let disconnectTimer = null; // 断开 重连倒计时
let lockReconnect = false; // 是否真正建立连接
let chatListEndTime = null; // 获取聊天数据的最后时间
let _this = null; // 转移this指向
let chatPath = '/doctorworkstation/newDiagnosis'; // 网诊聊天路径

//进入页面初始化websocket连接
function initWebSocketWebChat() {
  // 参数处理
  if (_this == null) _this = this;
  // 判断页面有没有存在websocket连接
  if (_this.$store.state.wsWebChat == null) {
    if (window.WebSocket) {
      // const wsUrl = `ws://8.133.165.236:80/ws?type=0&id=${_this.doctorId}`;
      // const wsUrl = `wss://www.xinglinct.com/ws?type=0&id=${_this.doctorId}`; //正式
      const wsUrl = `wss://test.xinglinct.com/ws?type=0&id=${_this.doctorId}`;   //测试
      _this.$store.state.wsWebChat = new WebSocket(wsUrl); // 创建长链接
      _this.$store.state.wsWebChat.onopen = webSocketOnOpen; // 连接成功
      _this.$store.state.wsWebChat.onerror = webSocketOnError; // 连接错误
      _this.$store.state.wsWebChat.onmessage = webSocketOnMessage; // 接收信息
      _this.$store.state.wsWebChat.onclose = webSocketOnClose; // 连接关闭
    }
  } else {
    _this.$store.state.wsWebChat = null;
    initWebSocketWebChat();
  }
}
// 连接成功事件
function webSocketOnOpen() {
  heartbeatStart(); // 开启心跳
}

// 获取聊天记录
async function getChatList(flag) {
  chatListEndTime = _this.$store.state.webChatList.length == 0 ? _this.$store.state.webChatEndTime : chatListEndTime;
  let params = {
    doctorId: _this.doctorId, patientId: _this.$route.query.patientId, pageSize: 15,
    pageNum: _this.$store.state.chatPageNum,webChatOrderInfoId:_this.$route.query.webChatOrderInfoId,role:1,
  };
  let { code, rows, total } = await chatList(params);
  if (code == 200) {
    _this.$store.state.chatPageNum ++;
    if (_this.$store.state.chatTotal == 0) _this.$store.state.chatTotal = total;
    // 创建语音
    rows.forEach(item => {
      item.type = item.sendRole;
      if (item.messageType == 3) {
        item.audio = new Audio(item.content);
        item.audio.addEventListener('loadedmetadata', () => {
          item.duration = Math.round(item.audio.duration);
          item.voiceIsPlaying = false;
          item.voicePlayTimer = null;
        });
      }
    });
    // 列表数据处理并赋值
    let listTimer = setTimeout(() => {
      _this.$store.state.webChatList = [...rows.reverse(), ..._this.$store.state.webChatList];
      if (!flag) scrollBottm(); // 滚动到底部
      _this.$forceUpdate();
      clearTimeout(listTimer);
    }, 200);
    _this.chatLoading = false;
  }
}

// 连接错误事件
function webSocketOnError() {
  reconnect(); // 重新连接
}

// 接收信息事件
function webSocketOnMessage(e) {
  reset(); // 收到服务器信息，心跳重置
  // 接收WebSocket返回的数据
  let data = JSON.parse(e.data);
  if (data.code == 0) {

    // 当前页面是开方页面，回填信息、滚动到页面底部、判断当前患者是否在线
    if (_this.$route.path == chatPath) {
      if (data.resultType == 0) {
        if (data.data.patientId == _this.$route.query.patientId) {
          _this.$store.state.webChatList.push(data.data);
          if(data.data.content=='患者问诊单填写完成'){
            _this.$store.state.chatPageNum=1
            _this.$store.state.webChatList=[]
            _this.$getChatList();
          }
          let rollBottomTimer = setTimeout(() => { // 滚动到底部
            scrollBottm();
            clearTimeout(rollBottomTimer);
          }, 500);
        };
      } else if (data.resultType == 1) { // 判断是否在线
        _this.$store.state.patientIsOnline = data.data;
        _this.$forceUpdate();
      }
    }

    // 计算新的网诊订单的数量
    let newWebChatNum = _this.$session.get('newWebChatNum');
    if (data.resultType == 0 && data.data.messageType == 6) {
      newWebChatNum ++;
      _this.$session.set('newWebChatNum', newWebChatNum);
      Bus.$emit('newWebChatNumBack', newWebChatNum);
    }

    // 处理网诊订单新消息数量
    let newMsgNum = _this.$session.get('newMsgNum') || []; // 从本地获取数量数组
    if (data.resultType == 0 && data.data.webChatOrderInfoId != _this.$route.query.webChatOrderInfoId && data.data.type == 1) {
      if (newMsgNum.length == 0) newMsgNum.push({ webChatOrderInfoId: data.data.webChatOrderInfoId, num :1 });
      else {
        newMsgNum.forEach(item => {
          if (item.webChatOrderInfoId == data.data.webChatOrderInfoId) item.num ++;
          else newMsgNum.push({ webChatOrderInfoId: data.data.webChatOrderInfoId, num :1 });
        });
      }
      _this.$session.set('newMsgNum', newMsgNum);
    }
  }
}

// 连接关闭事件
function webSocketOnClose() {
  reconnect();
}

// 连接失败重新连接
function reconnect() {
  if (lockReconnect) return;
  lockReconnect = true;
  disconnectTimer && clearTimeout(disconnectTimer);
  disconnectTimer = setTimeout(function () {
    initWebSocketWebChat();
    lockReconnect = false;
  }, 6000);
}

// 重置心跳
function reset(){
  clearTimeout(heartbeatTimer); // 清除心跳定时器
  clearTimeout(serverTimeoutTimer); // 清除服务器超时断连定时器
  heartbeatStart(); // 重启心跳
}

// 开启心跳
function heartbeatStart() {
  heartbeatTimer && clearTimeout(heartbeatTimer);
  serverTimeoutTimer && clearTimeout(serverTimeoutTimer);
  heartbeatTimer = setTimeout(() => {
    //这里发送一个心跳，后端收到后，返回一个心跳消息
    if (_this.$store.state.wsWebChat.readyState == 1) {
      _this.$store.state.wsWebChat.send("heartCheck"); // 如果连接正常
      if (_this.$route.path == chatPath) {
        _this.$store.state.wsWebChat.send(JSON.stringify({
          onLine: true, doctorId: _this.doctorId,
          patientId: _this.$route.query.patientId, type: 0
        })); // 判断是否在线
      }
    } else reconnect(); // 重新连接
    serverTimeoutTimer = setTimeout(() => { 
      _this.$store.state.wsWebChat.close();
    }, 30000);
  }, 30000);
}

// 发送消息
function sendText(webChatOrderInfoId) {
  let contentText = this.$store.state.contentText;
  if (contentText == '') this.$message.warning("不能发送空信息！");
  else {
    let isReply = this.webChatOrderInfo.isReply;
    let params = {
      patientId: this.$route.query.patientId, doctorId: this.doctorId,
      type: 0, messageType: 0, webChatOrderInfoId, content: contentText,
      isReply: isReply == 0 ? 0 : null
    };
    _this.$store.state.wsWebChat.send(JSON.stringify(params)); // 调用WebSocket send()发送信息的方法
    this.$store.state.contentText = "";
  }
  this.$refs.sendMsg.focus();
}

// 滚动条到底部
function scrollBottm() {
  if (document.querySelector('#msgBox')) {
    let msgBox = document.querySelector('#msgBox');
    let time = Math.ceil(msgBox.scrollHeight / 20), timer = null;
    timer = setInterval(() => {
      msgBox.scrollTop += 20;
      time --;
      if (time == 0) clearInterval(timer);
    }, 40);
  } else return;
}

export default { initWebSocketWebChat, sendText, getChatList };